


































import { Component, Prop, Ref, Vue } from 'vue-property-decorator';
import { RawLocation } from 'vue-router';
import LoadingAnimation from 'frontend/components/LoadingAnimation.vue';

@Component({
  components: {
    LoadingAnimation,
  },
})
export default class Button extends Vue {
  @Ref() public readonly button!: HTMLButtonElement;

  @Prop({ type: Boolean, default: false }) private readonly primary!: boolean;
  @Prop({ type: Boolean, default: false }) private readonly accent!: boolean;
  @Prop({ type: Boolean, default: false }) private readonly premium!: boolean;
  @Prop({ type: Boolean, default: false }) private readonly green!: boolean;
  @Prop({ type: Boolean, default: false }) private readonly red!: boolean;
  @Prop({ type: Boolean, default: false }) private readonly loading!: boolean;
  @Prop({ type: Boolean, default: false }) private readonly large!: boolean;
  @Prop({ type: Boolean, default: false }) private readonly small!: boolean;
  @Prop() private readonly to!: RawLocation;

  private get loadingAnimColor(): 'light' | 'dark' {
    if (this.primary || this.accent || this.green || this.red) {
      return 'light';
    }
    return 'dark';
  }

  private handleClick(e: MouseEvent) {
    (this.$el as HTMLElement).blur();
    this.$nextTick(() => {
      if (this.to && !e.defaultPrevented) {
        this.$router.push(this.to);
      }
    });
  }
}
